import { render, staticRenderFns } from "./DRSTBoxExpandableItem.vue?vue&type=template&id=f0ceaee6&scoped=true&"
import script from "./DRSTBoxExpandableItem.vue?vue&type=script&lang=ts&"
export * from "./DRSTBoxExpandableItem.vue?vue&type=script&lang=ts&"
import style0 from "./DRSTBoxExpandableItem.vue?vue&type=style&index=0&id=f0ceaee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ceaee6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0ceaee6')) {
      api.createRecord('f0ceaee6', component.options)
    } else {
      api.reload('f0ceaee6', component.options)
    }
    module.hot.accept("./DRSTBoxExpandableItem.vue?vue&type=template&id=f0ceaee6&scoped=true&", function () {
      api.rerender('f0ceaee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/DRSTBoxExpandableItem.vue"
export default component.exports